export const SetLocationMethod = {
	Geocode: "geocode",
	Coordinates: "coordinates",
	Draw: "draw",
} as const;

export type SetLocationMethod =
	(typeof SetLocationMethod)[keyof typeof SetLocationMethod];

export const SetLocationMode = {
	Set: "set",
	Edit: "edit",
} as const;

export type SetLocationMode =
	(typeof SetLocationMode)[keyof typeof SetLocationMode];

export const GeocodeSearchStatus = {
	Idle: "idle",
	Loading: "loading",
	Results: "results",
	Empty: "empty",
	Error: "error",
} as const;

export type GeocodeSearchStatus =
	(typeof GeocodeSearchStatus)[keyof typeof GeocodeSearchStatus];

export interface GeocodeCandidate {
	id: string;
	primary: string;
	magicKey: string;
	isCollection?: boolean;
	latitude?: number;
	longitude?: number;
	formattedAddress?: string;
}
